var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1973 3.39551C16.4785 3.67676 16.666 4.05176 16.666 4.45801V12.833C16.666 13.6768 15.9785 14.333 15.166 14.333H12.666V15.833C12.666 16.6768 11.9785 17.333 11.166 17.333H4.16602C3.32227 17.333 2.66602 16.6768 2.66602 15.833V5.83301C2.66602 5.02051 3.32227 4.33301 4.16602 4.33301H6.66602V2.83301C6.66602 2.02051 7.32227 1.33301 8.16602 1.33301H13.541C13.9473 1.33301 14.3223 1.52051 14.6035 1.80176L16.1973 3.39551ZM10.9785 15.833C11.0723 15.833 11.166 15.7705 11.166 15.6455V14.333H8.16602C7.32227 14.333 6.66602 13.6768 6.66602 12.833V5.83301H4.35352C4.22852 5.83301 4.16602 5.92676 4.16602 6.02051V15.6455C4.16602 15.7705 4.22852 15.833 4.35352 15.833H10.9785ZM14.9785 12.833C15.0723 12.833 15.166 12.7705 15.166 12.6455V6.33301H12.416C11.9785 6.33301 11.666 6.02051 11.666 5.58301V2.83301H8.35352C8.22852 2.83301 8.16602 2.92676 8.16602 3.02051V12.6455C8.16602 12.7705 8.22852 12.833 8.35352 12.833H14.9785ZM15.166 4.83301V4.55176C15.166 4.48926 15.1348 4.45801 15.1035 4.42676L13.5723 2.89551C13.541 2.86426 13.5098 2.83301 13.4473 2.83301H13.166V4.83301H15.166Z",
    fill: "#F2F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.d196d56366220e6228e641ebf99451d2.svg";
export { ForwardRef as ReactComponent };